export enum Permission {
  BasicAccess = 'BASIC_ACCESS',

  USER_EDIT = 'USER_EDIT',
  USER_READ = 'USER_READ',
  USER_CREATE = 'USER_CREATE',
  USER_UPDATE = 'USER_UPDATE',
  USER_DELETE = 'USER_DELETE',
  USER_IMPERSONATE = 'USER_IMPERSONATE',

  ROLE_READ = 'ROLE_READ',
  ROLE_UPDATE = 'ROLE_UPDATE',

  QUERY_READ = 'QUERY_READ',
  QUERY_CREATE = 'QUERY_CREATE',
  QUERY_UPDATE = 'QUERY_UPDATE',
  QUERY_DELETE = 'QUERY_DELETE',
  QUERY_EXECUTE_SQL = 'QUERY_EXECUTE_SQL',

  CHART_READ = 'CHART_READ',
  CHART_CREATE = 'CHART_CREATE',
  CHART_UPDATE = 'CHART_UPDATE',
  CHART_DELETE = 'CHART_DELETE',

  DASHBOARD_READ = 'DASHBOARD_READ',
  DASHBOARD_CREATE = 'DASHBOARD_CREATE',
  DASHBOARD_UPDATE = 'DASHBOARD_UPDATE',
  DASHBOARD_DELETE = 'DASHBOARD_DELETE',

  METADATA_READ = 'METADATA_READ',
  METADATA_UPDATE = 'METADATA_UPDATE',

  CONDITION_READ = 'CONDITION_READ',
  CONDITION_UPDATE = 'CONDITION_UPDATE',

  /** Also covers actions, bindings and notifications — they are all facets of the event framework. */
  EVENT_READ = 'EVENT_READ',
  EVENT_UPDATE = 'EVENT_UPDATE',

  /** Lets a user choose which LLM the AI assistant runs a turn against. */
  AI_MODEL_SELECT = 'AI_MODEL_SELECT',

  /** Lets a user read the AI quality/usage metrics of the tenant (the model comparison page). */
  AI_METRICS_READ = 'AI_METRICS_READ',
  /** Wiping the AI quality ledger to start a benchmark round from zero. Destroys data. */
  AI_METRICS_RESET = 'AI_METRICS_RESET',

  /** Lets a user switch feature flags on and off, and choose who has them (WB-186). */
  FEATURE_FLAG_ADMIN = 'FEATURE_FLAG_ADMIN',

  /** Lets a platform operator administer feature flags for the project level and every tenant. */
  FEATURE_FLAG_PLATFORM_ADMIN = 'FEATURE_FLAG_PLATFORM_ADMIN',
}

export type PermissionsOperation = 'ALL' | 'ANY' | 'NONE' | 'NOT ALL';
